let server = ""
if(!window.location.href.includes("localhost")){
    server = "/__extra/GuideSearchNew-Notices"
}
module.exports = server
